<template>
  <div v-loading="loading">
    <div v-if="loadingTemplate" class="well well-small">
      <el-row :gutter="20">
        <el-col>
          <RFMTrackingGlobalSection :rfmTracking="rfmTracking" />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <RFMTrackingContainerSection
            :rfmTrackingMessages="rfmTrackingMessages"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20"> </el-row>
      <el-row :gutter="20" type="flex" justify="end">
        <div style="padding-left: 10px;padding-top: 16px;">
          <span>{{ i18nValues["lastUpdate"] }} {{ lastUpdate | format }}</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import moment from "moment";
import RFMTrackingGlobalSection from "@/components/dashboard/sections/RFMTrackingGlobalSection.vue";
import RFMTrackingContainerSection from "@/components/dashboard/sections/RFMTrackingContainerSection.vue";

export default {
  name: "DMDashboard",
  created: function() {
    this.buildDash();
  },
  watch: {
    $route: function() {
      this.buildDash();
    },
  },
  components: {
    RFMTrackingGlobalSection,
    RFMTrackingContainerSection,
  },
  props: {},
  computed: {
    loadingDash: get("dashboard/loadingSnapshot"),
  },
  data() {
    return {
      fullscreenLoading: null,
      loading: true,
      loadingTemplate: false,
      snapshot: { activePromotions: 0 },
      dmSnapshot: { activePromotions: 0 },
      rfmPieChart: [],
      rfmTrackingMessages: [],
      lastUpdate: null,
    };
  },
  methods: {
    buildDash() {
      this.$store
        .dispatch("dashboard/retrieveRFMTracking")
        .then((response) => {
          this.snapshot = response;
          this.$store
            .dispatch("dashboard/retrieveDMSnapshot")
            .then((res) => {
              this.dmSnapshot = res;
              if (this.snapshot && this.dmSnapshot) {
                this.buildCharts();
                this.loading = this.loadingThreshold;
              }
            })
            .catch((error) => {
              console.log("error en retrieveDMSnapshot"); //eslint-disable-line
              this.$notify.error({
                title: this.i18nValues["error"],
                message: error,
                position: "bottom-right",
                duration: 7000,
              });
            });
        })
        .catch((error) => {
          console.log("error en retrieveRFMTracking"); //eslint-disable-line
          this.$notify.error({
            title: this.i18nValues["error"],
            message: error,
            position: "bottom-right",
            duration: 7000,
          });
        });
    },
    buildBarChart(dataSource) {
      var dates = [];
      var segments = [];
      var shortDates = [];
      var backgroundColor = this.dmSnapshot.rfmMap.map((a) => a.color);

      var datasets = [];
      dates = [...new Set(dataSource.map((a) => a.rfmProcessDate))];
      dates = dates.slice(-8);
      this.lastUpdate = dates[dates.length - 1];
      shortDates = dates.map((a) => a.slice(0, 10));

      segments = [...new Set(dataSource.map((a) => a.segmentId))];
      segments.forEach((segmentId) => {
        var data = [];
        let filteredBySegment = dataSource.filter(
          (a) => a.segmentId == segmentId
        );
        dates.forEach((date) => {
          let customerQtyByDateAndSegment = filteredBySegment
            .filter((a) => a.rfmProcessDate == date)
            .map((a) => a.customerQty);
          if (customerQtyByDateAndSegment.length == 0)
            customerQtyByDateAndSegment = [0];

          data.push(customerQtyByDateAndSegment.reduce((a, b) => a + b));
        });

        datasets.push({
          label: filteredBySegment[0].segmentDescription,
          borderColor: backgroundColor[segmentId - 1],
          backgroundColor: backgroundColor[segmentId - 1],
          hoverBorderColor: backgroundColor[segmentId - 1],
          data: data,
        });
      });

      return {
        labels: shortDates,
        datasets: datasets,
      };
    },
    buildCharts() {
      // Tracking Global Bars

      this.rfmTracking = this.buildBarChart(this.snapshot);

      // TrackingMessagesBar

      var rfmTrackingMessages = [];
      var messageIds = [...new Set(this.snapshot.map((a) => a.messageId))];
      messageIds.forEach((messageId) => {
        let filteredByMessageId = this.snapshot.filter(
          (a) => a.messageId == messageId
        );
        let builtChart = this.buildBarChart(filteredByMessageId);
        builtChart.messageId = messageId;
        builtChart.messageDescription =
          filteredByMessageId[0].messageDescription;
        rfmTrackingMessages.push(builtChart);
      });

      rfmTrackingMessages.shift();
      this.rfmTrackingMessages = rfmTrackingMessages.reverse();

      this.loadingTemplate = true;
    },
    formatTableDate(row) {
      return this.formatDate(row.lastDelivery);
    },
  },
  filters: {
    format(val) {
      let auxDate = moment(val, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    },
  },
};
</script>
